import {blockUi, unblockUi} from "@/modules/elements-blockui.js";
import {toggleAccordionCollapse} from "@/helpers/bootstrap-accordion-helper.js";

export function clearLayerSearch() {
    blockUi('.layer-menu', 0.6)
    setTimeout(() => {
        toggleAccordionCollapse('layer-menu', false)

        document.querySelector('layer-menu-overview').querySelectorAll('layer-menu-group').forEach(layerMenuGroup => {
            layerMenuGroup.classList.remove('d-none')
            layerMenuGroup.querySelectorAll('layer-menu-group-item, layer-menu-group-merged').forEach(layerMenuGroupItem => {
                layerMenuGroupItem.classList.remove('d-none')
            })

            const menuGroup = window.menuGroups.find(menuGroup => menuGroup.ID === parseInt(layerMenuGroup.dataset.id))
            if (menuGroup.open !== 1) {
                layerMenuGroup.querySelector('.collapse').classList.remove('show')
            }
        })
        setTimeout(() => {
            unblockUi('.layer-menu')
        }, 100)
    }, 100)
}
